import { Separator } from "@mindstonehq/ui";
import { Trans } from "@lingui/react/macro";

export default function ProfileLeft({
  profile,
}: {
  profile: {
    bio?: string | null;
    id: string;
  };
}) {
  if (!profile.bio) return null;

  return (
    <div className="flex flex-col gap-3">
      <div className="text-sm font-semibold leading-tight"><Trans>About</Trans></div>
      <div className="text-muted-foreground">{profile.bio}</div>
      <Separator />
    </div>
  );
}
